module.exports = {
      id: "food-stylist-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#food-stylist",
      toString: function () {
        return this.url;
      }
    }